import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR FLASH FLOOD",
      "steps": [
        "Stay Informed: Keep track of weather forecasts and warnings.",
        "Evacuation Plan: Have an evacuation plan in place for your family.",
        "Emergency Kit: Prepare an emergency kit with essential supplies.",
        "Move to Higher Ground: Move to higher ground if you are in a flood-prone area.",
        "Do Not Walk or Drive Through Floodwaters: Avoid walking or driving through flooded areas.",
        "Secure Valuables: Move valuable items to higher floors.",
        "Turn Off Utilities: Turn off gas, electricity, and water mains if instructed.",
        "Communicate: Stay in communication with family members and neighbors.",
        "Assist Neighbors: Check on neighbors, especially the elderly or disabled.",
        "Avoid Flooded Areas: Stay away from storm drains and flooded areas.",
        "Wait for the All-Clear: Only return home after authorities give the all-clear.",
        "Document Damage: Take photographs of flood-related damage.",
        "Report Incidents to Jal-Suraksha: Report incidents to Jal-Suraksha for prompt action."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const FloodFlash = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default FloodFlash;
